import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import * as AHooks from 'ahooks';
import { FUtil } from '@freelog/tools-lib';
import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import FIcons from '@/components/FIcons';

interface FFilePreviewerProps {
  url: string;
  mime: string;

  onClose(): void;
}

function FFilePreviewer({ url, mime, onClose }: FFilePreviewerProps) {

  return (<div className={styles.container}>

    {
      mime?.startsWith('image/') && (<Image url={url} />)
    }

    {
      mime?.startsWith('audio/') && (<audio controls src={url} />)
    }

    {
      mime?.startsWith('video/') && (<video controls src={url} />)
      // mime.startsWith('video/') && (<ReactPlayer url={url} />)
    }

    {
      mime?.includes('text/plain') && (<Text url={url} />)
    }

    <div
      className={styles.closeButton}
      onClick={() => {
        onClose?.();
      }}
    >
      <FIcons.FClose
        style={{ fontSize: 16, color: '#fff' }}
      />
    </div>
  </div>);
}

export default FFilePreviewer;

interface TextProps {
  url: string;
}

function Text({ url }: TextProps) {
  // console.log(url, 'url sdifjsdolikfjl;ksadjflkj');
  const [$text, set$text] = FUtil.Hook.useGetState<string>('');
  AHooks.useMount(async () => {

    const response = await fetch(url, {
      credentials: 'include',
    });
    const label = (response.headers.get('Content-Type') || '')
      .split(';')
      .find((c) => {
        return c?.startsWith('charset=');
      })
      ?.replace('charset=', '');
    const buffer = await response.arrayBuffer();
    const decoder = new TextDecoder(label || undefined);
    const text = decoder.decode(buffer);
    // console.log(text);
    set$text(text);
  });


  return (<div style={{
    width: 800,
    height: '100%',
    backgroundColor: 'white',
    padding: 20,
    overflowY: 'auto',
    overflowX: 'hidden',
  }}>
    {/*<Markdown>{$text}</Markdown>*/}
    <pre style={{ wordBreak: 'break-all', whiteSpace: 'pre-wrap' }}>{$text}</pre>
  </div>);
  // return null;
}

interface ImageProps {
  url: string;
}

function Image({ url }: ImageProps) {

  const [$scale, set$scale, get$scale] = FUtil.Hook.useGetState<number>(1);
  // console.log($scale, '$scaleiosdjf;lksdjf;lkjsdlk;jflksdjklfjlkj');
  return (<>
    <div
      style={{
        width: '100%',
        height: '100%',
        // backgroundImage: `url(${url})`,
        // backgroundRepeat: 'no-repeat',
        // backgroundSize: 'auto',
        // backgroundPosition: 'center',
        transform: `scale(${$scale})`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={url}
        alt={''}
        style={{
          maxHeight: '100%',
          maxWidth: '100%',
        }}
      />
    </div>

    <div
      className={styles.closeButton}
      style={{
        right: 100,
        ...($scale >= 5 ? {
          cursor: 'not-allowed',
          // opacity: .4,
        } : {}),
      }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (get$scale() >= 5) {
          return;
        }
        // onClose?.();
        set$scale(get$scale() + .1);

      }}
    >
      <ZoomInOutlined
        style={{ fontSize: 16, color: '#fff' }}
      />
    </div>

    <div
      className={styles.closeButton}
      style={{
        right: 150,
        ...($scale <= .2 ? {
          cursor: 'not-allowed',
          // opacity: .4,
        } : {}),
      }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();

        if (get$scale() <= .2) {
          return;
        }
        // onClose?.();
        set$scale(get$scale() - .1);

      }}
    >
      <ZoomOutOutlined style={{ fontSize: 16, color: '#fff' }} />
    </div>
  </>);
}
